import React from 'react';
import { TypedMemo } from '../../common/types';
import { SMLSettingsViewRenderer } from './SMLSettingsViewRenderer';
import { SettingsPageHead } from './SettingsPageHead';
import { useSettingsTabSelection } from './useSettingsTabSelection';
import { SMLContainer } from '../../smartLinks/smlContainer/SMLContainer';

/** Settings at `/app/settings?tab=<id>`. */
const SMLSettingsViewComponent: React.FC = () => {
  const { tabs, requestedTab, activeTab } = useSettingsTabSelection();

  return (
    <SMLContainer
      hidePricingModal
      header={<SettingsPageHead tabs={tabs} requestedTab={requestedTab} activeTab={activeTab} />}
    >
      <SMLSettingsViewRenderer />
    </SMLContainer>
  );
};

export const SMLSettingsView = TypedMemo(SMLSettingsViewComponent);
